import RouteContainer from 'containers/RouteContainer';
import Component from './containers/RelapseContainer';

import { editTitle } from 'lib/toolbar';

export const path = `${DOCUMENTS_PATH}/relapse`;
export const navigation = { name: 'relapse', id: 'relapse.title', viewTitle: 'relapse.viewTitle', editTitle };

export default RouteContainer(path, Component);
